/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2022 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
import { getUint8Array } from "@keeex/js-utils/lib/uint8array.js";
export default class WrappedCryptoKey {
  _key;
  _algorithm;
  constructor(key, algorithm) {
    this._key = key;
    this._algorithm = algorithm;
  }
  algorithm() {
    return this._algorithm;
  }
  forCipher() {
    return this._key;
  }
  async export() {
    return getUint8Array(await crypto.subtle.exportKey("raw", this._key));
  }
  /**
   * Convert a browser subtle key to the PureJS implementation CryptoKey
   */
  async toPureJsKey() {
    const keyData = await this.export();
    const {
      default: pureJsKeyImpl
    } = await import("@keeex/crypto-provider-purejs/lib/keys/cryptokey.js");
    return pureJsKeyImpl.importKeyData(this._algorithm, keyData);
  }
}
